import nextInspirationsApi from '@features/api/nextApiService/nextInspirationsApi';
import { TInspirationsTypesSlug } from '@features/cms/typescript';
const getArticlesWithTags = async (activeTagsId: number[], slug: TInspirationsTypesSlug) => {
  const nextApi = nextInspirationsApi;
  if (activeTagsId.length === 0) return {
    documents: []
  };
  const articlesTags = await nextApi.getArticlesWithTags(activeTagsId, slug);
  return articlesTags;
};
export default getArticlesWithTags;